import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 top-channels-for-dark" }
const _hoisted_2 = { class: "card-body p-25" }
const _hoisted_3 = { class: "px-0 mb-0 list-unstyled last-child-none pt-1" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_5 = { class: "flex-shrink-0" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "ms-3" }
const _hoisted_9 = { class: "mb-0 fs-14 fw-semibold" }
const _hoisted_10 = {
  class: "fs-12 d-block",
  style: {"margin-top":"2px"}
}
const _hoisted_11 = { class: "flex-grow-1 ms-3" }
const _hoisted_12 = { style: {"position":"absolute","width":"87%","height":"87%","background-color":"#ffffff","border-radius":"50%","display":"flex","align-items":"center","justify-content":"center"} }
const _hoisted_13 = {
  class: "text-body",
  style: {"font-size":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mb-4 d-flex justify-content-between align-items-center" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Top Channels"),
        _createElementVNode("a", {
          href: "#",
          class: "text-decoration-none hover"
        }, [
          _createTextVNode(" Browse All "),
          _createElementVNode("i", { class: "ri-arrow-right-s-line fs-22 lh-1 position-relative top-3" })
        ])
      ], -1)),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channels, (channel) => {
          return (_openBlock(), _createElementBlock("li", {
            key: channel.id,
            class: "mb-14 pb-14 border-bottom"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: channel.icon,
                    style: {"max-width":"25px"},
                    alt: channel.name
                  }, null, 8, _hoisted_7),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h4", _hoisted_9, _toDisplayString(channel.name), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(channel.category), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: "ms-auto",
                  style: _normalizeStyle({
                  position: 'relative',
                  width: '43px',
                  height: '43px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: `conic-gradient(${channel.color} ${channel.percentage}%, #ffffff ${channel.percentage}%)`,
                })
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(channel.percentage) + "% ", 1)
                  ])
                ], 4)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}